export default "__VITE_ASSET__DhzkBKW$__"